// Auto-generated from the-great-war.docx — see scripts/ for regeneration notes.
const BOOK_DATA = {
  "title": "the great war",
  "parts": [
    {
      "title": "Part 1",
      "chapters": [
        {
          "number": 1,
          "title": "Chapter 1",
          "paragraphs": [
            {
              "type": "p",
              "text": "Hi, I’m Emmett, the author of this story you’re reading now. This tale is about the Great War."
            },
            {
              "type": "p",
              "text": "Deep in an ancient forest, a camp stirred with strange, restless energy. Units moved purposefully through the shadows, their bodies unlike anything humans had ever seen. They resembled humanoid bats, yet they had no faces, no ears, and no toes. Golden helmets sat upon their heads, gleaming like the beaks of birds. From each helmet’s narrow slit trailed a single strand of smooth, black hair, long and whip-like, swaying as they marched."
            },
            {
              "type": "p",
              "text": "The camp itself was alive with otherworldly technology. Along one side stood three Unit Warpers — portals of shimmering light through which new soldiers stepped into being, warped in from the distant creation sector. (A sector, in this war, was not a country but a whole cluster of galaxies.) High above it all, a fourth portal shimmered atop a gleaming pedestal, its surface glowing with a steady hum of power."
            },
            {
              "type": "p",
              "text": "All around the camp, Workers toiled silently. These headless, neckless creatures looked like hollow versions of the Units, stripped of helmets and armor. They harvested essence from the forest plants, slashing each plant and taking the green glowing sphere that appeared.  Each sphere glowed faintly, and though the Workers drew thousands of them, the plants remained untouched. With perfect precision, the Workers carried the essence to the pedestal portal, where it vanished in a blink — warped back to the manufacturing sector. There, it powered machines that built everything from teleportation belts to golden Bloodhound suits."
            },
            {
              "type": "p",
              "text": "Every faction in the war had its strength."
            },
            {
              "type": "p",
              "text": "The Shadow Armada held the most essence, their power drawn from endless harvest."
            },
            {
              "type": "p",
              "text": "The prism Armada commanded raw strength and overwhelming attack power."
            },
            {
              "type": "p",
              "text": "The Roboto Armada relied on numbers, their endless machines flooding every battlefield."
            },
            {
              "type": "p",
              "text": "Among the Shadow forces, none were more feared than the Bloodhounds. Though they resembled knights at first glance, they were something far stranger. Their bodies were smooth and black, flecked with tiny dots of gold and silver that shimmered when they moved. From their heads flowed dark hair connected to their spines by a thin, fin-like ridge, allowing them to twist and dart through the air with impossible speed. Unlike the bare Workers, Bloodhounds wore full-body suits of pure gold, gleaming brighter than fire in the dim forest. The Bloodhounds prowled near the edge of the forest, golden armor glinting faintly in the dim light."
            },
            {
              "type": "p",
              "text": "Obsidian’s eyes caught a sharp shimmer far off, rising above the trees. His chest tightened, and his golden armor suddenly felt heavier than ever."
            },
            {
              "type": "p",
              "text": "“Onyx…” he whispered, his voice trembling. “Do you see that? That fortress… I—I don’t like it. I’m so scared! What if they’ve already noticed us?”"
            },
            {
              "type": "p",
              "text": "Onyx tilted her head slightly, the fin along her spine twitching. She didn’t answer right away, but a ripple of unease passed between them. The forest was too quiet, every shadow stretching longer than it should, as if the trees themselves were holding their breath."
            },
            {
              "type": "p",
              "text": "High above, the distant spires of the Prism base shimmered, catching the sun like a thousand shards of glass. The quiet tension between the two scouts pressed down like a weight, and in that instant, Obsidian felt the first stirring of the storm to come."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "But beyond the Shadow forest stood something just as formidable: the fortress of the Prism Armada. Where the Shadow camp was dark and alive with essence, the Prism base gleamed like a world sculpted from light. Towering spires of alabaster rose above a castle of pure prism, its walls shimmering with rainbow fire."
            },
            {
              "type": "p",
              "text": "The soldiers of the Prism Armada were stranger still. They marched in flawless silence, their bodies smooth and white as carved crystal. Faces without features reflected the forest around them like disoriented glass, giving no hint of thought or feeling. When they moved, they caught the sunlight in blinding flashes, as if a thousand shards of glass had risen and taken shape."
            },
            {
              "type": "p",
              "text": "Two powers, two armies, two ways of war. Soon, the quiet forest would be shattered by their clash."
            }
          ]
        },
        {
          "number": 2,
          "title": "Chapter 2",
          "paragraphs": [
            {
              "type": "p",
              "text": "Prism stood atop her gleaming white pedestal, from which she commanded her forces. She was a perfect copy of her soldiers, gleaming white as if carved from living crystal. Though she mirrored their every move, there was something unsettlingly alive in the way she shifted, something that made the air around her feel colder."
            },
            {
              "type": "p",
              "text": "A voice broke the silence."
            },
            {
              "type": "p",
              "text": "“Miss, we found the camp,” a mysterious figure rasped. Shadows hid their face, but their body shimmered white, flickering like shards of broken crystal."
            },
            {
              "type": "p",
              "text": "Prism did not answer. She did not even blink. her soldiers waited, unmoving, as if her next thought alone could command them."
            },
            {
              "type": "p",
              "text": "Finally, her cold, distant voice carried across the courtyard:"
            },
            {
              "type": "p",
              "text": "“Align. Advance. Let nothing falter.”"
            },
            {
              "type": "p",
              "text": "Instantly, the Prism Armada moved as one, each soldier stepping into formation with unerring precision. The spires of alabaster gleamed in the rising sun, and the forest beyond waited unknowingly for the storm about to descend."
            }
          ]
        },
        {
          "number": 3,
          "title": "Chapter 3",
          "paragraphs": [
            {
              "type": "p",
              "text": "Obsidian was scared. The energy exploding around him could kill him in an instant. He ducked and dodged, moving backward instead of advancing. His mentor would be ashamed of him right now. No — he had to focus. Don’t stop until they’re all dead, the voice of his mentor rang through his head, sharp and unyielding."
            },
            {
              "type": "p",
              "text": "Golden armor flashed as Bloodhounds twisted through the air, weaving between streaks of white light and shards of crystal. Obsidian’s teeth gritted. Focus. Survive. Protect the camp."
            },
            {
              "type": "p",
              "text": "He tried to stick to the shadows, just like his mentor had drilled into him. Of course, he failed. Sunlight glinted off his golden armor — curse that gold for being so shiny!"
            },
            {
              "type": "p",
              "text": "Then he tripped over a stick. How does someone even do that? And just as he was about to jump out and strike the Prism soldier, a rabbit darted across his path, startling him."
            },
            {
              "type": "p",
              "text": "He stumbled backward, heart racing, almost getting hit! Scrambling for cover, he dove behind the pedestal, panting and shaking."
            },
            {
              "type": "p",
              "text": "A shard of movement caught his eye. A single Prism soldier glided forward, white as polished crystal, reflecting the forest around it. Obsidian froze. Don’t move. Don’t breathe."
            },
            {
              "type": "p",
              "text": "Then a whisper of thought passed through his mind: This isn’t a full attack. It’s just a warning."
            },
            {
              "type": "p",
              "text": "Before he could decide what to do, Onyx appeared, slicing through the shadows, the fin along her spine twitching. She intercepted the Prism soldier with a precise strike, her golden armor flashing."
            },
            {
              "type": "p",
              "text": "Obsidian’s fear surged, then faltered. He couldn’t just watch. He leapt from cover, slashing and twisting in unison with Onyx. Together, they struck the Prism soldier down, its white body shattering into fragments that glittered in the sun before fading."
            },
            {
              "type": "p",
              "text": "Panting, Obsidian crouched beside Onyx, adrenaline racing. The forest was silent again, but the warning hung in the air. This wasn’t just a skirmish — it was a message. And whatever was coming next would be far, FAR. worse."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Then Obsidian saw Shadowfin emerge from one of the portals, flanked by about 400 soldiers! If he was right and they were about to attack the Prism Armada, this battle would be huge — and he wasn’t sure he would survive it."
            },
            {
              "type": "p",
              "text": "they moved out keeping to the shadows the tall grass around the fortress gave obsidian and the rest of the soldiers plenty of cover after everyone was in position they attacked beams and arrows and swords. that was all he could see just beams and arrows and swords. then the world focused and he saw he was in for it. a prism armada soldier was standing right in front of him. he yelped as he dodged beam after beam after beam. then the soldier was tackled by umber \"thanks\" he yelled over the chaos"
            },
            {
              "type": "p",
              "text": "\"don't mention it\" he yelled back as he fought the soldier. then, he got hit by a beam, and he was gone."
            }
          ]
        },
        {
          "number": 4,
          "title": "Chapter 4",
          "paragraphs": [
            {
              "type": "p",
              "text": "Obsidian didn’t know what to do. The battle was over, but his friend was gone. The image of Umber falling replayed in his mind again and again, a wound that no blade could match."
            },
            {
              "type": "p",
              "text": "He clenched his fists. He had been reckless, careless, thinking survival was enough. But now he knew the truth. This wasn’t a game. This wasn’t training."
            },
            {
              "type": "p",
              "text": "This was war."
            },
            {
              "type": "p",
              "text": "And if he wanted to live through it, he would have to be sharper, stronger, and far more careful than he had ever been before."
            },
            {
              "type": "p",
              "text": "“Hey! Obsidian! Come help us build!” shouted the captain of the Workers."
            },
            {
              "type": "p",
              "text": "Obsidian jogged over, still stiff from the fight. He bent to lift one of the massive obsidian bricks, but it barely budged. Heat rose to his face. The others moved them with ease, yet he couldn’t even get one off the ground."
            },
            {
              "type": "p",
              "text": "Frustrated, he left the wall and slipped into the trees, where the older Bloodhounds were training. He mimicked their movements, slashing at bark and stumbling through their footwork drills. Each strike echoed with his vow: stronger, faster, better — never helpless again."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "A messenger burst through one of the portals, breathless. “Obsidian! Onyx! Shadowkiller! Nightfang! Shadowmaw! Umbrith! Gloomfang!  We need you—come with me!” He waved frantically for them to follow."
            },
            {
              "type": "p",
              "text": "They sprinted after him, claws digging into the dirt, until they reached a nearby camp under siege. A massive force of Prism Armada warriors was swarming the defenses, beams and crystal shards lighting the air with deadly brilliance."
            },
            {
              "type": "p",
              "text": "Obsidian and Onyx charged into the fray. Almost at once, the Prism soldiers pressed in around them, outnumbering them on every side. Obsidian’s heart pounded, but he forced himself to move—dodge, strike, twist. Every lesson, every drill, every word of his mentor’s training came roaring back to him."
            },
            {
              "type": "p",
              "text": "And for the first time, he didn’t freeze. He fought."
            },
            {
              "type": "p",
              "text": "His sword struck true, his movements sharp and focused. One Prism soldier fell—then another—and another. Three enemies down by his own strength. Obsidian’s chest burned with effort, but when the remaining Prism forces finally retreated into the trees, a spark of pride flickered in him."
            },
            {
              "type": "p",
              "text": "He had survived. He had fought. And he had won."
            },
            {
              "type": "p",
              "text": "He stayed overnight at the camp, and when morning came, reinforcements arrived to strengthen their defenses. But before the Bloodhounds were ready, before the patrols had even settled in, disaster struck."
            },
            {
              "type": "p",
              "text": "Out of the tall bushes burst a swarm of Prism Armada soldiers — a hundred, maybe a hundred and fifty of them — leaping into the camp with beams blazing. In the first heartbeat of battle, half of the defenders were cut down before they could even react."
            },
            {
              "type": "p",
              "text": "The Bloodhounds fought back with everything they had, but it was no use. The Prism soldiers were relentless, their crystal weapons burning through armor and flesh alike. Finally, the call to retreat rang out, and the survivors stumbled back toward the fortress. Of the proud force that had stood there at dawn, only sixteen remained."
            },
            {
              "type": "p",
              "text": "The Prism Armada clearly wanted the territory the Shadow Armada now held, because they attacked again and again. Each time, Obsidian cut through more soldiers, sometimes stepping in just in time to save his comrades."
            },
            {
              "type": "p",
              "text": "With every clash, the fortress held. Slowly, the small camps expanded into towns, and before long the Shadow Armada had a solid base. Obsidian was stationed in Acres, the largest town, surrounded by farmland that fed their forces."
            },
            {
              "type": "p",
              "text": "But as the battles dragged on, the stronger and older Bloodhounds began to fall. Each assault chipped away at their defenses, until finally the Shadow Armada struck back with a massive attack of their own. In that battle, Obsidian fought harder than he ever had before, proving himself again and again. and the Shadow Armada gained a fortress."
            },
            {
              "type": "p",
              "text": "One day, as he was training with the other Bloodhounds, Shadowfin approached. His presence cast a long shadow across the field, and his deep, booming voice carried over the sound of clashing practice blades."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "“Obsidian, a word.”"
            },
            {
              "type": "p",
              "text": "“Yes, sir?” Obsidian replied, heart pounding. A knot of fear twisted in his chest — he braced himself for the worst."
            },
            {
              "type": "p",
              "text": "“In your opinion, which two soldiers would you work best with?” Shadowfin asked."
            },
            {
              "type": "p",
              "text": "“Onyx and… well… I—I don’t know, sir,” Obsidian admitted."
            },
            {
              "type": "p",
              "text": "“Well, you’ve got a promotion. You’re now captain of a patrol team,” Shadowfin said with a rare grin. “You’ll be in charge of two soldiers. Which ones will you command?”"
            },
            {
              "type": "p",
              "text": "Obsidian’s heart raced. A captain? Him? He thought hard, the weight of the decision pressing on him. Finally, he said, “Onyx… and a random soldier, please.”"
            },
            {
              "type": "p",
              "text": "“Alright… your second soldier will be… hm… oh! I know—Shadeclaw!”"
            },
            {
              "type": "p",
              "text": "A moment later, Shadowfin returned with the most stunning Bloodhound Obsidian had ever seen. Shadeclaw’s black body shimmered with flecks of gold and silver, like stars scattered across a night sky. Her flowing dark hair framed her face, and the gleaming gold armor she wore made her look regal—majestic and dangerous all at once."
            },
            {
              "type": "p",
              "text": "“Obsidian!” Shadowfin barked suddenly."
            },
            {
              "type": "p",
              "text": "“whatshappeningwhatsgoingon?!” Obsidian screeched, sending birds flying from the trees."
            },
            {
              "type": "p",
              "text": "Onyx burst out laughing. “You were staring at Shadeclaw like a poor villager who just got handed ten bars of gold,” she teased. “While Shadowfin was asking if you’re okay with her being on your team.”"
            },
            {
              "type": "p",
              "text": "Obsidian’s face burned hot. “I’m… I’m okay with it,” he mumbled, his cheeks warming even more under Shadeclaw’s curious gaze."
            },
            {
              "type": "p",
              "text": "Onyx was still snickering her face off as the moment faded."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "The next day, more soldiers arrived to strengthen the defenses around the new fortress. Obsidian and his team were reassigned to guard the fortress itself, while lower-ranked Bloodhounds were sent to set up camps along the perimeter. The Shadow Armada was expanding, and with every camp raised, the war grew larger—and more dangerous."
            }
          ]
        },
        {
          "number": 5,
          "title": "Chapter 5",
          "paragraphs": [
            {
              "type": "p",
              "text": "Obsidian stepped out of the fortress into a crisp autumn morning. The air carried the smell of fallen leaves and smoke from the training fires. His days had fallen into a steady rhythm—patrols at dawn, lunch with his fellow Bloodhounds, then training until the sun dipped low. For a whole week, it was like this. Quiet. Almost normal."
            },
            {
              "type": "p",
              "text": "Every now and then, though, a messenger would arrive with grim news: another town under attack. Those reminders kept the soldiers sharp, even during the calm."
            },
            {
              "type": "p",
              "text": "Then Shadowfin sent Obsidian and Shadeclaw out on a scouting mission, while Onyx stayed behind to train—she needed the exercise."
            },
            {
              "type": "p",
              "text": "“So…” Shadeclaw said after a while. “When I fight, I keep thinking of my home… it keeps me going. What keeps you going, Obsidian?”"
            },
            {
              "type": "p",
              "text": "“I… I think of the people I care about, the ones who could get hurt if I stand down,” he replied, avoiding eye contact so she wouldn’t notice the heat rising in his cheeks."
            },
            {
              "type": "p",
              "text": "“Hey, Captain Mopey—if you swing that blade any harder, you’ll cut down the whole forest,” she teased, her grin bright."
            },
            {
              "type": "p",
              "text": "“See, but then we could build something here,” he shot back, smirking."
            },
            {
              "type": "p",
              "text": "But then, mid-swing, something caught his eye—a sharp glint between the trees. His heart skipped. He motioned for Shadeclaw to duck low, and together they crept into the shadows."
            },
            {
              "type": "p",
              "text": "What they saw froze them in place."
            },
            {
              "type": "p",
              "text": "All along the edge of the forest stretched a Prism city. Gleaming walls. Towering spires. Soldiers everywhere."
            },
            {
              "type": "p",
              "text": "It was the most terrifying sight either of them had ever faced."
            }
          ]
        },
        {
          "number": 6,
          "title": "Chapter 6",
          "paragraphs": [
            {
              "type": "p",
              "text": "They ran back through the forest as fast as they could. Once they were within range, Obsidian and Shadeclaw activated their warping devices and blinked straight to the fortress."
            },
            {
              "type": "p",
              "text": "Luckily, Shadowfin was outside when they appeared. Gasping for breath, they spilled out everything they had seen—the Prism soldiers, the shimmering towers, the endless city on the forest’s edge."
            },
            {
              "type": "p",
              "text": "Onyx came out to meet them, wiping sweat from her brow after training. Her smile vanished as soon as she saw their faces."
            },
            {
              "type": "p",
              "text": "Shadowfin’s expression was calm, but his eyes darkened. “A whole city…” he murmured. “This changes everything.”"
            },
            {
              "type": "p",
              "text": "Things grew more serious with every passing day. Training became brutal, every drill twice as long as before. Hundreds of new soldiers arrived at the fortress each morning, swelling the Shadow Armada’s ranks until the courtyards and camps overflowed with tents, weapons, and marching feet."
            },
            {
              "type": "p",
              "text": "It was all work and no rest. Obsidian and his comrades barely had time to sleep, and the rare quiet moments they found were spent sharpening blades or checking armor straps. Even laughter felt rare now, as if the air itself had grown too heavy to carry joy."
            },
            {
              "type": "p",
              "text": "Onyx grumbled during training, though even her jokes sounded strained. Shadeclaw tried to keep spirits up, but her smile often faded when she thought no one was looking. Obsidian noticed. The worry was spreading, taking over the soldiers like a parasite that no blade could cut away."
            },
            {
              "type": "p",
              "text": "Every order Shadowfin gave reminded them of the Prism city on the horizon. Patrols were doubled. Camps were shifted closer to the fortress walls. The farmland that once looked peaceful was now laced with watchtowers, trenches, and spikes."
            },
            {
              "type": "p",
              "text": "Obsidian found himself staring out at the forest each night, the trees whispering in the autumn wind. He couldn’t shake the feeling that something was out there, waiting. Watching."
            },
            {
              "type": "p",
              "text": "The army was preparing for a siege… but the Prism Armada was already closer than they realized."
            },
            {
              "type": "p",
              "text": "The first scream cut through the night like a blade."
            }
          ]
        },
        {
          "number": 7,
          "title": "Chapter 7",
          "paragraphs": [
            {
              "type": "p",
              "text": "Prism soldiers leapt from every hiding place—holes, bushes, behind trees. They swarmed like shadows brought to life."
            },
            {
              "type": "p",
              "text": "But this time, the Shadow Armada was ready."
            },
            {
              "type": "p",
              "text": "Obsidian slashed down two soldiers before they even reached him. Blinding beams lit the battlefield, arrows whistled through the air, piercing Prism warriors where they stood. The death toll mounted fast: for every Shadow soldier who fell, ten Prism soldiers went with them."
            },
            {
              "type": "p",
              "text": "Through the chaos, Obsidian’s eyes locked on a Prism captain. Twin glowing blades shimmered in his hands, deadly and precise. Obsidian charged. Steel clashed in a storm of sparks, and with every ounce of strength in his body, he drove his blade forward. The Prism captain crumpled, the glow in his weapons flickering out."
            },
            {
              "type": "p",
              "text": "Then the ground erupted. Hidden mines, triggered by the weight of battle, launched a barrage of tiny missiles into the ranks of the Prism Armada. Explosions tore through their forces, scattering bodies and smoke across the field."
            },
            {
              "type": "p",
              "text": "When the dust cleared, most of the Prism soldiers were gone. The few survivors fled back into the forest, disappearing into the shadows they had crawled from."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Shadowfin came out to greet them. “Obsidian. Shadeclaw. Onyx,” he said firmly. “I must speak with you in my office.”"
            },
            {
              "type": "p",
              "text": "He led them through the fortress halls until they reached the topmost chamber. His office was made almost entirely of glass, the wide windows overlooking the fortress grounds. From above, the soldiers patrolling below looked like moving shadows."
            },
            {
              "type": "p",
              "text": "“Sit,” Shadowfin ordered. The chairs were stone-hard and uncomfortable, but none of them dared to complain."
            },
            {
              "type": "p",
              "text": "“You have all shown great skill in battle,” he began. “So you will be chosen as leaders of a new camp.”"
            },
            {
              "type": "p",
              "text": "They gasped."
            },
            {
              "type": "p",
              "text": "“Obsidian will take command as camp leader,” Shadowfin continued. “Shadeclaw and Onyx will each lead patrol teams under his command.”"
            },
            {
              "type": "p",
              "text": "“WHAT?!” Shadeclaw practically leapt from her seat. She rushed forward and tackle-hugged Shadowfin before realizing what she was doing. “Sorry! I’m just—just so excited! Obsidian, this is the highest honor a Bloodhound has ever gotten!”"
            },
            {
              "type": "p",
              "text": "Obsidian forced a small smile. “Cool, I guess…” But inside, his stomach twisted. It didn’t sound like an honor. It sounded like a curse. Like Bloodhounds only lived long enough to rise in rank—then died soon after."
            },
            {
              "type": "p",
              "text": "Shadowfin’s voice lowered, the glass walls around them catching the weight of his words. “Do not mistake this honor for safety. Leadership paints a target on your back. The Prism Armada will strike harder than ever, and your soldiers will look to you when fear takes hold. If you falter, they falter. If you fall…” His gaze lingered on Obsidian. “So will they.”"
            },
            {
              "type": "p",
              "text": "The room fell silent. Even Shadeclaw stopped bouncing with excitement, her smile fading. Shadowfin straightened, his expression unreadable. “That is all. Prepare yourselves.”"
            }
          ]
        },
        {
          "number": 8,
          "title": "Chapter 8",
          "paragraphs": [
            {
              "type": "p",
              "text": "Obsidian’s new camp smelled of sawdust, sweat, and smoke. The Shadow Armada had wasted no time—tents were rising in rows, fences hammered into place, and patrols already marching the perimeter. From the moment he stepped into it, Obsidian knew this was different from the fortress. This was his responsibility now."
            },
            {
              "type": "p",
              "text": "Shadeclaw and Onyx stood at his side, waiting for orders, their eyes shining with expectation. The weight of leadership pressed against his chest. He wanted to feel proud, but all he could think of was Shadowfin’s words echoing in his head: If you want to survive, you’ll need more than skill. You’ll need wisdom."
            },
            {
              "type": "p",
              "text": "Obsidian tightened his grip on his sword hilt. He didn’t feel wise. He felt like a Bloodhound pup thrown into a storm. But he couldn’t show it—not now."
            },
            {
              "type": "p",
              "text": "Obsidian stood before the gathered Bloodhounds, his new patrol force. He decided the best way to begin was simple: learn who they were."
            },
            {
              "type": "p",
              "text": "He raised his voice. “Alright, one by one. Tell me your name—and how you feel about fighting for the Shadow Armada.”"
            },
            {
              "type": "p",
              "text": "Shadowkiller stepped forward first, huge muscles rippling. He grinned like the battlefield was his favorite place. “I like fighting. The harder the battle, the better.”"
            },
            {
              "type": "p",
              "text": "Nightfang followed, her golden flecks shining faintly. “Like Shadeclaw,” Obsidian thought, though not as striking. She said calmly, “I live for the hunt. I won’t let you down.”"
            },
            {
              "type": "p",
              "text": "Shadowmaw only gave a curt nod. “Don’t talk much. I fight. That’s all.”"
            },
            {
              "type": "p",
              "text": "Obscura’s eyes blazed as she snapped, “Finally, a commander who asks. About time. Just point me at the Prism Armada—I’ll tear them apart.”"
            },
            {
              "type": "p",
              "text": "Umbrith bowed slightly. “I fight to honor my clan. My blades are yours, Captain.”"
            },
            {
              "type": "p",
              "text": "Gloomfang gave a low chuckle. “Heh. If death comes, I’ll meet it smiling.”"
            },
            {
              "type": "p",
              "text": "Veilstrike smirked. “Fast, quiet, deadly—that’s me. Just don’t get in my way.”"
            },
            {
              "type": "p",
              "text": "Darklash pounded his fist to his chest. “Every swing of my blade is for the Shadow Armada’s glory!”"
            },
            {
              "type": "p",
              "text": "Onyxclaw stepped forward, eyes locked on Obsidian. “Strong name, strong arm. I’ll keep the patrol line solid.”"
            },
            {
              "type": "p",
              "text": "Duskfang shrugged. “Not much to say. Orders come, I follow. Enemies come, I cut them down.”"
            },
            {
              "type": "p",
              "text": "Silentmaw said nothing at first, but then added in a soft rasp, “Silence is my strength. You’ll see it on the battlefield.”"
            },
            {
              "type": "p",
              "text": "Blackthorn looked away, muttering, “I don’t fight for glory. Just survival.”"
            },
            {
              "type": "p",
              "text": "Emberveil gave a sly grin. “I like the fire of battle. Makes me feel alive.”"
            },
            {
              "type": "p",
              "text": "Nightlash cracked his knuckles. “I’ll guard this camp with my life. Nobody gets past me.”"
            },
            {
              "type": "p",
              "text": "Phantomclaw leaned on his weapon. “I prefer shadows to speeches. But I’ll do what must be done.”"
            },
            {
              "type": "p",
              "text": "Veyra folded her arms. “I’m not here to make friends. I’m here to win.”"
            },
            {
              "type": "p",
              "text": "Ebonfang’s voice was deep and steady. “I’ll strike hard, I’ll strike true. Count on me.”"
            },
            {
              "type": "p",
              "text": "Murkwing flexed the black feathers of his cloak. “You need eyes in the dark? That’s me.”"
            },
            {
              "type": "p",
              "text": "Grimveil gave a small, humorless smile. “I already buried my fear. Nothing left but steel.”"
            },
            {
              "type": "p",
              "text": "Shiverfang’s hands trembled—but he smirked through it. “Nerves? Sure. But that won’t stop me cutting throats.”"
            },
            {
              "type": "p",
              "text": "Tenebra tilted her head, voice smooth. “I move like nightfall. Quiet, certain, and inevitable.”"
            },
            {
              "type": "p",
              "text": "Nyxclaw growled low. “Prism blood tastes sweet. I want more.”"
            },
            {
              "type": "p",
              "text": "Omenfang gave Obsidian a piercing stare. “I see omens in every battle. Your rise is one of them.”"
            },
            {
              "type": "p",
              "text": "Wraithclaw hissed through clenched teeth. “I fight like the dead themselves. They’ll never see me coming.”"
            },
            {
              "type": "p",
              "text": "Ashenfang rubbed a scar across his muzzle. “Fire burned my home. I’ll burn them in return.”"
            },
            {
              "type": "p",
              "text": "Noctira bowed gracefully. “I fight with balance, with purpose. Death does not scare me.”"
            },
            {
              "type": "p",
              "text": "Ravenspike flicked a black spear in his hand. “Let me at ’em. I’ll skewer their hearts clean.”"
            },
            {
              "type": "p",
              "text": "Umbrafang cracked a smile. “I thrive in darkness. Lead, and I’ll follow"
            },
            {
              "type": "p",
              "text": "Nightveil lowered her hood, voice like velvet. “The night is my weapon, Captain. And I am its blade.”"
            },
            {
              "type": "p",
              "text": "When the last name was spoken, Obsidian looked at them all—so many personalities, all fierce in their own way. A strange mix of pride and fear twisted in his chest. These are my soldiers, he thought. And whether they know it or not, their lives are in my hands."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "as the days past he learned that life as the captan of a camp is not hard at all. I mean sure the job felt dounting at first, but he got use to it. then the attack came."
            }
          ]
        },
        {
          "number": 9,
          "title": "Chapter 9",
          "paragraphs": [
            {
              "type": "p",
              "text": "Swords clashed and arrows whistled past, the sound of steel striking steel echoing through the trees. He saw that all his warriors were obviously the best of the best but they weren’t better than him. He was cutting soldiers down left and right, his blade flashing in the chaos. Through the smoke, he spotted a Prism captain locked in battle with Nyxclaw. Without hesitation, Obsidian charged in to help. Together, they struck fast and hard, cutting the captain down."
            },
            {
              "type": "p",
              "text": "When the fighting finally eased, Obsidian called for the medics to tend to the wounded. He walked among his soldiers, offering a hand here, a word of praise there. “Hey, good job out there,” he said to one. “You did fantastic,” to another."
            },
            {
              "type": "p",
              "text": "Even in the middle of war, he made sure his soldiers knew their worth."
            },
            {
              "type": "p",
              "text": "After about a month, their camp had started to look more like a town. The soldiers were living better, and even civilians had begun to move in. Towers now stood tall along the perimeter, each armed with turrets that watched the forest like silent guardians."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "That night, the fire crackled softly at the center of camp. The smell of roasted meat drifted through the air as laughter echoed between the tents. For the first time in months, the Bloodhounds weren’t sharpening their blades or polishing armor—they were just talking."
            },
            {
              "type": "p",
              "text": "Obsidian sat beside Shadeclaw, their shoulders brushing now and then as they watched the flames dance. Around them, his team was finally loosening up."
            },
            {
              "type": "p",
              "text": "Nyxclaw was telling a story about how she once scared off three Prism scouts just by yelling at them. “They thought I was some kind of monster!” she boomed, slapping her knee."
            },
            {
              "type": "p",
              "text": "Shadeclaw giggled. “That’s because you are some kind of monster. Have you seen yourself when you wake up?”"
            },
            {
              "type": "p",
              "text": "The whole group laughed. Even Obsidian cracked a smile."
            },
            {
              "type": "p",
              "text": "When the laughter died down, Shadeclaw leaned toward him and said softly, “You’ve changed, you know. You’re calmer now. Stronger. They look up to you.”"
            },
            {
              "type": "p",
              "text": "Obsidian poked the fire with a stick. “Maybe. I just don’t want anyone else to die because I didn’t do enough.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw’s smile faded a little. “That’s not how it works. You can’t save every-\""
            },
            {
              "type": "p",
              "text": "\"but that's what I'm doing!\" he shot back. \"have you watched someone you care about die?!\" good he thought when she looked at the stars and didn't respond."
            },
            {
              "type": "p",
              "text": "The fire popped, sending a shower of sparks into the cool night air."
            },
            {
              "type": "p",
              "text": "For a while, no one spoke. The forest whispered quietly around them, and above, the stars shimmered like silver eyes watching over the Bloodhounds."
            },
            {
              "type": "p",
              "text": "It almost felt safe. Almost peaceful."
            },
            {
              "type": "p",
              "text": "But deep down, Obsidian couldn’t shake the feeling that this calm wouldn’t last forever."
            }
          ]
        },
        {
          "number": 10,
          "title": "Chapter 10",
          "paragraphs": [
            {
              "type": "p",
              "text": "as obsidian thought, The peace didn’t last. The first sign was the tremor in the ground—steady, mechanical, too perfect to be natural. Then came the sound, a deep metallic roar that rolled through the trees."
            },
            {
              "type": "p",
              "text": "Obsidian rushed to the perimeter wall and froze. Beyond the forest’s edge, metal glinted in the sunlight. Dozens—no, hundreds—of machines were marching in formation."
            },
            {
              "type": "quote",
              "text": "The Roboto Armada had arrived."
            },
            {
              "type": "p",
              "text": "They were taller than humans—massive metal giants with double-barreled machine guns mounted on their forearms and missile launchers on their shoulders. The first barrage tore through the towers, turning them into fire and rubble."
            },
            {
              "type": "p",
              "text": "Arrows rained down from above, but they bounced harmlessly off the robots’ steel plating. Still, Obsidian refused to back down. He steadied his bow, aimed for the narrow strip of glass that served as the bots’ visors—and let fly."
            },
            {
              "type": "p",
              "text": "The arrow struck true. The robot froze, sparks flickering inside its head before it collapsed with a heavy clang."
            },
            {
              "type": "p",
              "text": "“Aim for the visors!” Obsidian shouted."
            },
            {
              "type": "p",
              "text": "The barricaded soldiers echoed his call, firing arrow after arrow at the weak points. One by one, the bots fell, crashing to the ground like broken towers of metal."
            },
            {
              "type": "p",
              "text": "Obsidian leapt from the wall, blades flashing as he sliced through the ranks of fallen machines. Dodging the bullets was almost second nature now—it was like fighting the Prism Armada all over again. Every move, every strike felt familiar. Controlled. Deadly."
            },
            {
              "type": "p",
              "text": "But then—"
            },
            {
              "type": "p",
              "text": "A flash of light. A missile screaming through the air."
            },
            {
              "type": "p",
              "text": "It struck Shadeclaw."
            },
            {
              "type": "p",
              "text": "“No!”"
            },
            {
              "type": "p",
              "text": "He sprinted through the smoke, cutting down any robot that stood in his way. When he reached her, she was crumpled on the ground, smoke rising from the blast mark beside her. He lifted her into his arms and ran toward the town as fast as he could, the battle raging behind him."
            },
            {
              "type": "p",
              "text": "In the medic’s room, they hooked her up to a strange humming machine, its lights flickering weakly. Obsidian didn’t move. He just sat there, hands shaking, staring at her pale face as tears streamed down his cheeks."
            },
            {
              "type": "p",
              "text": "The medics said that she wouldn’t make it."
            },
            {
              "type": "p",
              "text": "But he kept praying anyway."
            }
          ]
        },
        {
          "number": 11,
          "title": "Chapter 11",
          "paragraphs": [
            {
              "type": "p",
              "text": "The head medic finally approached him, voice low and uncertain."
            },
            {
              "type": "p",
              "text": "“Her wounds should have healed,” she whispered. “But something from that blast is still hurting her. It’s… like fire that got inside her body.”"
            },
            {
              "type": "p",
              "text": "Obsidian lifted his head. “Fire… inside?”"
            },
            {
              "type": "p",
              "text": "The medic shook her head, defeated. “We don’t understand it. The explosion left behind something invisible—something that’s weakening her from the inside out. Her pulse is faint. Her body is fighting, but whatever hit her was more than a missile.”"
            },
            {
              "type": "p",
              "text": "She hesitated. “We’ve never seen a weapon like this before.”"
            },
            {
              "type": "p",
              "text": "Obsidian stared at Shadeclaw for a long moment, jaw tightening. Leaving her felt wrong—like turning his back on someone who needed him—but he knew he had responsibilities outside those walls."
            },
            {
              "type": "p",
              "text": "He forced himself to stand. “Sorry… I have to go,” he said quietly. “I’ll check in soon.”"
            },
            {
              "type": "p",
              "text": "He stepped out of the medic’s room, letting the door close softly behind him."
            },
            {
              "type": "p",
              "text": "As Obsidian stepped outside, the air felt colder than before—quiet, heavy, almost swollen with worry. The world was moving, but it felt slower… dimmer… like someone had taken a piece of its fire away."
            },
            {
              "type": "p",
              "text": "A crowd stood waiting for him."
            },
            {
              "type": "p",
              "text": "Onyx was at the front, armor dented, eyes wide. The rest of the camp—soldiers, medics, even civilians—watched him silently from behind. Every face carried the same question."
            },
            {
              "type": "p",
              "text": "Onyx took a hesitant step forward. “…Is she okay? Obsidian, what happened in there?”"
            },
            {
              "type": "p",
              "text": "Obsidian swallowed hard. He wanted to tell them Shadeclaw was fine. He wanted to say the medics had a plan. He wanted hope."
            },
            {
              "type": "p",
              "text": "But his voice came out hoarse. “She’s alive,” he said. “But the blast did something… something we don’t understand.”"
            },
            {
              "type": "p",
              "text": "A ripple of whispers spread through the crowd."
            },
            {
              "type": "p",
              "text": "Before Onyx could ask anything more, a shadow fell over them. Shadowfin strode toward Obsidian with urgency in his steps and storm clouds in his eyes."
            },
            {
              "type": "p",
              "text": "“Obsidian,” he said quietly but firmly, “I need to speak with you. Now. Privately.”"
            },
            {
              "type": "p",
              "text": "The crowd parted as Shadowfin motioned him toward the fortress steps. Obsidian gave his soldiers one last look—worried faces, tired bodies, people depending on him even when he felt anything but strong."
            },
            {
              "type": "p",
              "text": "He straightened."
            },
            {
              "type": "p",
              "text": "“I’ll be back,” he promised them."
            },
            {
              "type": "p",
              "text": "Then he followed Shadowfin inside, each step heavier than the last."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Shadowfin told Obsidian that the king had been informed of the attack immediately. The scientists had already been summoned, tasked with forging stronger metals for their blades—materials that could stand against the weapons of the Roboto Armada. Then came the hard part."
            },
            {
              "type": "p",
              "text": "“Obsidian,” Shadowfin said quietly, “do you have any inkling of what happened to Shadeclaw?”"
            },
            {
              "type": "p",
              "text": "“Ye—” Obsidian began, his voice catching."
            },
            {
              "type": "p",
              "text": "The doors burst open."
            },
            {
              "type": "p",
              "text": "“Shadowfin!” the head medic shouted, rushing in, breathless. “Guess what? We know what’s going on!”"
            }
          ]
        },
        {
          "number": 12,
          "title": "Chapter 12",
          "paragraphs": [
            {
              "type": "p",
              "text": "“Radiation!” she screamed, the word bursting out of her like she’d been holding it in too long. “That’s what we’re calling it, anyway.”"
            },
            {
              "type": "p",
              "text": "She took a breath, forcing herself to calm down. “The missile didn’t just wound Shadeclaw—it left something behind. Invisible. Poisonous. It seeps into the body and keeps burning long after the blast.”"
            },
            {
              "type": "p",
              "text": "Obsidian’s fists clenched. “Can you stop it?”"
            },
            {
              "type": "p",
              "text": "“Yes,” the medic said quickly. “We’re extracting it and converting it into essence. It’s dangerous work, but it’s working.” Her voice softened. “If everything continues as planned, she should be out of bed rest in about… two weeks.”"
            },
            {
              "type": "p",
              "text": "For the first time since the battle, Obsidian felt the crushing weight on his chest ease—just a little."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Obsidian raced down the corridor toward Onyx. As he passed an open doorway, raised voices stopped him cold."
            },
            {
              "type": "p",
              "text": "“The king is going too far!” someone hissed."
            },
            {
              "type": "p",
              "text": "“Yeah! We can’t keep doing this—it’s evil!”"
            },
            {
              "type": "p",
              "text": "“You will abide by the rules made by the king!” Shadowfin roared."
            },
            {
              "type": "p",
              "text": "“Shadowfin, Korrin’s right,” another voice said. “The king needs to chill!”"
            },
            {
              "type": "p",
              "text": "“STOP TALKING, VANTHEL!” Shadowfin screamed."
            },
            {
              "type": "p",
              "text": "“Bro!” Korrin exclaimed."
            },
            {
              "type": "p",
              "text": "The door slammed open."
            },
            {
              "type": "p",
              "text": "Shadowfin stepped out—and his eyes locked onto Obsidian."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "He took a deep breath and whispered, “What are you doing?!”"
            },
            {
              "type": "p",
              "text": "Shadowfin’s voice snapped back, sharp and cold. “I will call the king and let him decide whether you three are banished or put in a cell.” He pointed toward the door. “Meanwhile—leave.”"
            },
            {
              "type": "p",
              "text": "They didn’t argue. The moment the door shut behind them, Korrin exhaled."
            },
            {
              "type": "p",
              "text": "“Dude,” he said, glancing at Obsidian, “why’d you eavesdrop?”"
            },
            {
              "type": "p",
              "text": "“I don’t know…” Obsidian admitted."
            },
            {
              "type": "p",
              "text": "“You just felt the urge?” Vanthel asked."
            },
            {
              "type": "p",
              "text": "“Yeah. How’d you know?”"
            },
            {
              "type": "p",
              "text": "Vanthel shrugged and tugged his bangs down, half-hiding his face. “I don’t know…”"
            },
            {
              "type": "p",
              "text": "Korrin snorted. “Vanthel’s part of a scientific project,” he explained."
            },
            {
              "type": "p",
              "text": "“Project… huh?” Obsidian frowned, thinking. “Oh—wait. Dark Warrior?”"
            },
            {
              "type": "p",
              "text": "“Stop!” Vanthel snapped, a little too loudly."
            },
            {
              "type": "p",
              "text": "They had reached the docking bay now, where shuttles rested on metal rails, ready to carry soldiers to distant towns.“Hey… why don’t you come with me?”"
            },
            {
              "type": "p",
              "text": "“That was the O.G. plan!” Korrin said with a grin."
            },
            {
              "type": "p",
              "text": "“Great.”"
            }
          ]
        },
        {
          "number": 13,
          "title": "Chapter 13",
          "paragraphs": [
            {
              "type": "p",
              "text": "They reached the town just as word spread. A crowd had already gathered, voices overlapping with fear and hope."
            },
            {
              "type": "p",
              "text": "“Is Shadeclaw alive?” “Did she make it?” “How bad is it?”"
            },
            {
              "type": "p",
              "text": "Obsidian stopped in the middle of the street, heart pounding. Then he smiled — a real, bright smile — and raised his voice."
            },
            {
              "type": "p",
              "text": "“She’ll be okay!!!!”"
            },
            {
              "type": "p",
              "text": "Cheers broke out. Relief rippled through the crowd like a wave. For a moment, everything else disappeared — the king, the arguments, the secrets, the war. None of it mattered."
            },
            {
              "type": "p",
              "text": "Obsidian ran."
            },
            {
              "type": "p",
              "text": "He burst into the medic’s hall, barely slowing down — and there she was."
            },
            {
              "type": "p",
              "text": "Shadeclaw lay propped up on the bed, pale and weak, but her eyes were open."
            },
            {
              "type": "p",
              "text": "“Obsidian,” she croaked."
            },
            {
              "type": "p",
              "text": "That was it. He melted — completely. Tears spilled before he could stop them as he rushed to her side and wrapped her gently in his arms."
            },
            {
              "type": "p",
              "text": "“I thought I was going to lose you,” he sobbed, his voice breaking."
            },
            {
              "type": "p",
              "text": "She smiled faintly and leaned into him, alive."
            }
          ]
        },
        {
          "number": 14,
          "title": "Chapter 14",
          "paragraphs": [
            {
              "type": "p",
              "text": "Days passed. Shadeclaw was finally released from bed rest, and for the first time in a long while, life felt peaceful. No attacks. No alarms."
            },
            {
              "type": "p",
              "text": "Then disaster struck."
            },
            {
              "type": "p",
              "text": "A shuttle descended from the sky, loaded with soldiers from the King’s Black Guard—the most elite army in the Shadow Armada."
            },
            {
              "type": "p",
              "text": "Obsidian’s stomach dropped."
            },
            {
              "type": "p",
              "text": "They were looking for him."
            },
            {
              "type": "p",
              "text": "He gathered as many people as he could who stood at his side, who believed in him. Whatever he had started, he could feel it now—something dangerous, something unstoppable."
            },
            {
              "type": "p",
              "text": "He didn’t know what it was yet."
            },
            {
              "type": "p",
              "text": "They ran through the woods, leaving everything behind."
            },
            {
              "type": "p",
              "text": "Their old lives were gone—cast aside, replaced by the life of rebels."
            },
            {
              "type": "p",
              "text": "They didn’t stop until they reached the deepest part of the forest, a place few dared to enter and fewer could survive."
            },
            {
              "type": "p",
              "text": "There, hidden beneath towering trees and tangled shadows, they set up camp."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "He tried to keep everyone’s spirits up, but it was harder than he expected. The camp was heavy with fear. Soldiers grumbled through footwork drills."
            },
            {
              "type": "p",
              "text": "“We’re gonna die.” “I can’t believe this.”"
            },
            {
              "type": "p",
              "text": "Obsidian stopped them."
            },
            {
              "type": "p",
              "text": "He stepped forward, voice steady even though his chest was tight. “Everyone—listen to me.”"
            },
            {
              "type": "p",
              "text": "The camp fell quiet."
            },
            {
              "type": "p",
              "text": "“How do we stop the cruelty the king sends into the world?” he shouted. “By making a stand!”"
            },
            {
              "type": "p",
              "text": "Murmurs rippled through the crowd."
            },
            {
              "type": "p",
              "text": "“How do we protect our people—our families, our daughters, our sons, our wives and husbands who couldn’t come with us?” “By making a stand!”"
            },
            {
              "type": "p",
              "text": "His voice grew stronger, sharper."
            },
            {
              "type": "p",
              "text": "“And how do we end the king’s cruelty?” He raised his blade. “By MAKING A STAND!!!!!!”"
            },
            {
              "type": "p",
              "text": "This time, the answer came back louder."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "This. Was. War. And he would have to survive it like this—apparently."
            }
          ]
        }
      ]
    },
    {
      "title": "Act 2",
      "chapters": [
        {
          "number": 15,
          "title": "Chapter 15",
          "paragraphs": [
            {
              "type": "p",
              "text": "Obsidian sat by the campfire, slowly sharpening a blade. The steady scrape of stone against metal was almost soothing, the firelight flickering across the steel. Around him, the camp murmured with low voices and restless movement, but he stayed focused on his work."
            },
            {
              "type": "p",
              "text": "Korrin approached quietly and sat down beside him."
            },
            {
              "type": "p",
              "text": "“Dude,” he said, glancing at the blade, “you don’t sharpen a sword like someone who plans to sleep.”"
            },
            {
              "type": "p",
              "text": "Obsidian didn’t look up."
            },
            {
              "type": "p",
              "text": "Korrin lowered his voice. “They look up to you. Every single one of them. If we’re going to strike back… all you have to do is say the word.”"
            },
            {
              "type": "p",
              "text": "Obsidian finally stopped sharpening. His grip tightened around the hilt."
            },
            {
              "type": "p",
              "text": "“It’s too much,” he said. “I’m not some hero who swoops in and saves the day. I’m just… Obsidian.”"
            },
            {
              "type": "p",
              "text": "Korrin smiled. “Well, just Obsidian—we have reinforcements.”"
            },
            {
              "type": "p",
              "text": "As if summoned by his words, Bloodhound after Bloodhound came running into the clearing, armor clinking, eyes burning with determination."
            },
            {
              "type": "p",
              "text": "Suddenly, one soldier pushed to the front, panic clear in his voice."
            },
            {
              "type": "p",
              "text": "“Captain Obsidian!” he shouted. “They destroyed the entire town! We have to get off this planet before they find us!”"
            }
          ]
        },
        {
          "number": 16,
          "title": "Chapter 16",
          "paragraphs": [
            {
              "type": "p",
              "text": "“Okay… this is interesting,” Obsidian whispered to himself."
            },
            {
              "type": "p",
              "text": "He looked up at the group. “We should move toward the Roboto Armada. If we can find their base, we could try to become allies—use their technology to get off this world.”"
            },
            {
              "type": "p",
              "text": "Korrin let out a short laugh. “Yeah… easier said than done. Not even the Shadow Armada knows where they’re hiding.”"
            },
            {
              "type": "p",
              "text": "The others nodded in agreement."
            },
            {
              "type": "p",
              "text": "Obsidian frowned, thinking. Then his eyes sharpened."
            },
            {
              "type": "p",
              "text": "“When they attack us—and they will—we don’t just fight them.”"
            },
            {
              "type": "p",
              "text": "The camp went quiet."
            },
            {
              "type": "p",
              "text": "“We ask for their help.”"
            },
            {
              "type": "p",
              "text": "A wave of confused murmurs spread through the group."
            },
            {
              "type": "p",
              "text": "“…ohhh…”"
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "It had been three days since the reinforcements arrived, and for the first time in a long while, the crushing weight they had been carrying felt lighter."
            },
            {
              "type": "p",
              "text": "Almost."
            },
            {
              "type": "p",
              "text": "It was late afternoon when they heard it—a low, rumbling sound rolling through the forest."
            },
            {
              "type": "p",
              "text": "Heads snapped up."
            },
            {
              "type": "p",
              "text": "Yes."
            },
            {
              "type": "p",
              "text": "Every one of them knew that sound. The Roboto Armada."
            },
            {
              "type": "p",
              "text": "Hope sparked—dangerous, desperate hope."
            },
            {
              "type": "p",
              "text": "Then it came."
            },
            {
              "type": "p",
              "text": "War horns."
            },
            {
              "type": "p",
              "text": "Battle cries."
            },
            {
              "type": "p",
              "text": "The Shadow Armada had found them too."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "“Everyone, push toward the bots!” Obsidian shouted, his voice barely cutting through the roar of battle. “They’ve agreed—fight the Shadow Armada!”"
            },
            {
              "type": "p",
              "text": "For a split second, no one moved."
            },
            {
              "type": "p",
              "text": "Then the resistance turned, breaking away from the fighting and sprinting toward the towering machines."
            },
            {
              "type": "p",
              "text": "Three bots stepped forward, their metal frames gleaming through the smoke. Without a word, they signaled—and began leading the group deeper into the forest."
            },
            {
              "type": "p",
              "text": "Behind them, the sounds of the battle raged on."
            },
            {
              "type": "p",
              "text": "Ahead… something new awaited."
            }
          ]
        },
        {
          "number": 17,
          "title": "Chapter 17",
          "paragraphs": [
            {
              "type": "p",
              "text": "They reached the camp—though it looked nothing like one."
            },
            {
              "type": "p",
              "text": "Towering structures rose from the ground, more like massive factories than shelters, their metal walls humming with constant motion."
            },
            {
              "type": "p",
              "text": "The first thing they noticed was the silence."
            },
            {
              "type": "p",
              "text": "No voices. No footsteps. No life."
            },
            {
              "type": "p",
              "text": "Only machines."
            },
            {
              "type": "p",
              "text": "Robots moved in perfect patterns, working without pause, without sound beyond the low mechanical hum that filled the air."
            },
            {
              "type": "p",
              "text": "Obsidian’s eyes scanned the place, searching for any sign of something familiar. There was none."
            },
            {
              "type": "p",
              "text": "“This is… concerning,” he mumbled."
            },
            {
              "type": "p",
              "text": "A strange, small robot rolled toward them. Its movements were smooth—almost too smooth."
            },
            {
              "type": "p",
              "text": "It stopped in front of Obsidian."
            },
            {
              "type": "p",
              "text": "“Your ship will be ready soon,” it said."
            },
            {
              "type": "p",
              "text": "Its voice was calm. Natural. Almost human."
            },
            {
              "type": "p",
              "text": "For a second, they could have sworn it was alive."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "As they moved deeper into the Roboto Armada base, Obsidian began to understand the true scale of its power. Towering metal structures stretched endlessly into the sky, their lights glowing through the haze. Every building hummed with machinery, creating an eerie feeling that settled deep in his chest."
            },
            {
              "type": "p",
              "text": "“Why is there no life here?” Obsidian finally asked."
            },
            {
              "type": "p",
              "text": "The small robot didn’t hesitate."
            },
            {
              "type": "p",
              "text": "“The king and his advisors are the only living beings in the entire Roboto Armada,” it stated plainly."
            },
            {
              "type": "p",
              "text": "Silence followed."
            },
            {
              "type": "p",
              "text": "A heavy, uncomfortable silence."
            },
            {
              "type": "p",
              "text": "They continued walking until the factories came into view—massive shipbuilding structures so enormous they looked like metal mountains. Giant transport ships hung above rivers of molten steel while thousands of machines worked in perfect synchronization below."
            },
            {
              "type": "p",
              "text": "“You will board a transport vessel bound for the Roboto Armada homeworld,” the robot explained."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "When they boarded the transport ship, whispers spread through the rebels."
            },
            {
              "type": "p",
              "text": "“We’re refugees…” “How did this happen?” “I hope Obsidian can fix this.”"
            },
            {
              "type": "p",
              "text": "The words hit harder than any blade."
            },
            {
              "type": "p",
              "text": "Everyone strapped themselves in as the robots calmly went through the safety protocols in their flat, emotionless voices."
            },
            {
              "type": "p",
              "text": "Shadeclaw sat beside Obsidian."
            },
            {
              "type": "p",
              "text": "As the ship broke through the atmosphere and the planet disappeared beneath them, she finally spoke."
            },
            {
              "type": "p",
              "text": "“Don’t let what they say get to you,” she said softly. “You’re doing your best.”"
            },
            {
              "type": "p",
              "text": "She reached for his hand."
            },
            {
              "type": "p",
              "text": "Obsidian stared ahead. “I’m stuck. If I fail, we die. If we go back, we die.”"
            },
            {
              "type": "p",
              "text": "“And if we succeed?”"
            },
            {
              "type": "p",
              "text": "He let out a humorless laugh. “You know that won’t happen.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw shook her head."
            },
            {
              "type": "p",
              "text": "“If we succeed,” she whispered, “the Shadow Armada will become better than it’s ever been.”"
            },
            {
              "type": "p",
              "text": "She paused."
            },
            {
              "type": "p",
              "text": "“Because you’ll be king.”"
            },
            {
              "type": "p",
              "text": "She rested her head against his shoulder."
            },
            {
              "type": "p",
              "text": "“Thank you,” Obsidian whispered, tears welling in his eyes."
            },
            {
              "type": "p",
              "text": "A robotic voice suddenly echoed through the cabin."
            },
            {
              "type": "p",
              "text": "“Sir, we have arrived. You may wish to compose yourself before meeting our king.”"
            },
            {
              "type": "p",
              "text": "The captain robot stood motionless near the front of the ship."
            },
            {
              "type": "p",
              "text": "Shadeclaw smiled faintly."
            },
            {
              "type": "p",
              "text": "“You’ve got this, Obsidian,” she whispered into his ear before kissing him gently on the cheek."
            },
            {
              "type": "p",
              "text": "Obsidian froze for a second, completely speechless."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "When Obsidian stepped out of the ship, he froze in amazement."
            },
            {
              "type": "p",
              "text": "Vast fields of wildflowers stretched across the landscape, swaying beneath towering metal buildings suspended on enormous iron supports above them. Lights glowed softly from the structures overhead, casting golden reflections across the flowers below."
            },
            {
              "type": "p",
              "text": "In the distance stood an even larger structure—a massive castle of silver and black metal rising into the sky."
            },
            {
              "type": "p",
              "text": "The small robot pointed toward it."
            },
            {
              "type": "p",
              "text": "“The king awaits.”"
            },
            {
              "type": "p",
              "text": "The castle was close enough to warp to, so Obsidian did."
            },
            {
              "type": "p",
              "text": "A flash later, he stood inside an enormous hall of polished metal and glowing white lights. At the far end, a figure waited for him."
            },
            {
              "type": "p",
              "text": "“Hello,” the figure said calmly. “You must be the leader of the Shadow Armada rebels. I am Gongui. What is your name?”"
            },
            {
              "type": "p",
              "text": "“Obsidian, sir,” he replied. “Thank you for taking my people in.”"
            },
            {
              "type": "p",
              "text": "“Of course,” Gongui said. “Come inside. We have negotiations to make.”"
            },
            {
              "type": "p",
              "text": "They sat across from each other in surprisingly comfortable leather chairs inside a warm living room. An artificial fire crackled nearby, its orange glow reflecting off the metallic walls."
            },
            {
              "type": "p",
              "text": "“Now,” Gongui said, folding his hands together, “what do you propose?”"
            },
            {
              "type": "p",
              "text": "Obsidian took a breath."
            },
            {
              "type": "p",
              "text": "“I want your help destroying the king of the Shadow Armada.”"
            },
            {
              "type": "p",
              "text": "Gongui tilted his head slightly."
            },
            {
              "type": "p",
              "text": "“I am already attempting to do that,” he said plainly. “What else do you want?”"
            },
            {
              "type": "p",
              "text": "“If I become king of the Shadow Armada, I want your support… so our armadas will never have to fight again.”"
            },
            {
              "type": "p",
              "text": "Gongui nodded slowly."
            },
            {
              "type": "p",
              "text": "“Fair.”"
            },
            {
              "type": "p",
              "text": "The word hung in the air for a moment before he continued."
            },
            {
              "type": "p",
              "text": "“Now, what is your plan?”"
            },
            {
              "type": "p",
              "text": "“If we can defeat the Shadow Armada on the planet we just escaped from, we can secure a stronger base of operations.”"
            },
            {
              "type": "p",
              "text": "Gongui’s glowing eyes narrowed slightly."
            },
            {
              "type": "p",
              "text": "“And how would we accomplish that with the Prism Armada still in the way?”"
            },
            {
              "type": "p",
              "text": "Obsidian hesitated."
            },
            {
              "type": "p",
              "text": "Gongui stood."
            },
            {
              "type": "p",
              "text": "“Go back to the fields,” he said. “My robots have prepared a place for your people to rest. For tonight, remove this weight from your shoulders. We will continue tomorrow.”"
            },
            {
              "type": "p",
              "text": "Obsidian nodded and left the castle, choosing to walk back through the fields instead of warping this time."
            }
          ]
        },
        {
          "number": 18,
          "title": "Chapter 18",
          "paragraphs": [
            {
              "type": "p",
              "text": "When Obsidian returned, he spotted the remains of a campfire glowing softly in the dark. Shadeclaw sat beside it, quietly poking at the coals with a stick."
            },
            {
              "type": "p",
              "text": "He walked over and sat down next to her."
            },
            {
              "type": "p",
              "text": "“How are you?” he asked."
            },
            {
              "type": "p",
              "text": "“Good,” she replied softly. “How did the negotiations go?”"
            },
            {
              "type": "p",
              "text": "Obsidian stared into the fire. “I… don’t know.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw blinked. “Huh. Weird.”"
            },
            {
              "type": "p",
              "text": "He glanced at her and noticed something was wrong. She looked sad."
            },
            {
              "type": "p",
              "text": "“What’s up?”"
            },
            {
              "type": "p",
              "text": "She hesitated. “They wouldn’t let me come with you.”"
            },
            {
              "type": "p",
              "text": "“Oh.”"
            },
            {
              "type": "p",
              "text": "Obsidian’s thoughts spiraled instantly. Shadeclaw—Shadeclaw—had actually been worried about not being with him. His heart raced in a thousand different directions all at once."
            },
            {
              "type": "p",
              "text": "“I’m sorry,” she whispered."
            },
            {
              "type": "p",
              "text": "“For what?” he asked quickly. “Why would you feel sorry about anything?”"
            },
            {
              "type": "p",
              "text": "Shadeclaw looked down at the fire."
            },
            {
              "type": "p",
              "text": "“For the kiss earlier. It was ridiculous.”"
            },
            {
              "type": "p",
              "text": "Obsidian felt tears sting his eyes."
            },
            {
              "type": "p",
              "text": "“It was one of the best moments of my life.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw looked back up at him, grinning softly. Then she wrapped her arms around him."
            },
            {
              "type": "p",
              "text": "“I’m really glad you liked it,” she whispered."
            },
            {
              "type": "p",
              "text": "She kissed him again."
            },
            {
              "type": "p",
              "text": "This time, he kissed her back."
            },
            {
              "type": "p",
              "text": "For a moment, the war felt impossibly far away."
            },
            {
              "type": "p",
              "text": "Eventually, Shadeclaw smiled and stood up."
            },
            {
              "type": "p",
              "text": "“Goodnight.”"
            },
            {
              "type": "p",
              "text": "Obsidian hesitated for only a second."
            },
            {
              "type": "p",
              "text": "“Love you.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw’s smile widened."
            },
            {
              "type": "p",
              "text": "“Love you too, Obsidian.”"
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Obsidian and Gongui were beginning to form a solid plan."
            },
            {
              "type": "p",
              "text": "Gongui would send every robot he could spare to Foranar 5. Their forces would break through part of the Shadow Armada’s wall and escort Obsidian and the rebels safely to the Prism Armada."
            },
            {
              "type": "p",
              "text": "If the alliance succeeded, all three forces would launch a combined assault against the Shadow Armada’s control over the planet."
            },
            {
              "type": "p",
              "text": "For the first time in a long while… victory almost felt possible."
            },
            {
              "type": "p",
              "text": "In only a few days, preparations would be complete."
            },
            {
              "type": "p",
              "text": "“Hello, Obsidian.”"
            },
            {
              "type": "p",
              "text": "The voice echoed through the corridor."
            },
            {
              "type": "p",
              "text": "Obsidian turned, expecting Gongui."
            },
            {
              "type": "p",
              "text": "Instead, Shadowfin stepped from the shadows."
            },
            {
              "type": "p",
              "text": "Obsidian froze."
            },
            {
              "type": "p",
              "text": "“I have come with reinforcements,” Shadowfin said calmly."
            },
            {
              "type": "p",
              "text": "Suddenly, hundreds of Bloodhounds poured into the hall behind him, armor clanking as they moved."
            },
            {
              "type": "p",
              "text": "Obsidian stared in disbelief."
            },
            {
              "type": "p",
              "text": "Shadowfin gave a faint smile."
            },
            {
              "type": "p",
              "text": "“Goodbye, young one.”"
            },
            {
              "type": "p",
              "text": "Then, before Obsidian could respond, he disappeared."
            }
          ]
        },
        {
          "number": 19,
          "title": "Chapter 19",
          "paragraphs": [
            {
              "type": "p",
              "text": "Anticipation hung over everyone like a storm cloud."
            },
            {
              "type": "p",
              "text": "Bloodhounds sharpened their blades. Robots marched endlessly toward transports bound for Foranar 5. Everywhere Obsidian looked, he saw the same realization in people’s eyes:"
            },
            {
              "type": "p",
              "text": "Many of them were going to die for this cause."
            },
            {
              "type": "p",
              "text": "Tomorrow could be their last tomorrow."
            },
            {
              "type": "p",
              "text": "Obsidian hated the feeling growing inside him."
            },
            {
              "type": "p",
              "text": "Shadeclaw walked over quietly and sat beside him."
            },
            {
              "type": "p",
              "text": "“Don’t worry,” she said softly. “The robots will escort us.”"
            },
            {
              "type": "p",
              "text": "Obsidian shook his head."
            },
            {
              "type": "p",
              "text": "“I feel like everyone’s relying on these negotiations to work out.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw wrapped her arms around him."
            },
            {
              "type": "p",
              "text": "“You’ll do great.”"
            },
            {
              "type": "p",
              "text": "“Awwww… look who it is,” a voice called out. “The Shadow Armada’s cutest couple.”"
            },
            {
              "type": "p",
              "text": "Korrin approached with a crooked grin, though there was bitterness behind it. Ever since the new Bloodhounds arrived, he’d been in a terrible mood."
            },
            {
              "type": "p",
              "text": "Obsidian sighed."
            },
            {
              "type": "p",
              "text": "“As the leader of this group, I’m ordering you to stop. You’ve been rude to every Bloodhound here ever since they arrived.”"
            },
            {
              "type": "p",
              "text": "Korrin’s expression darkened instantly."
            },
            {
              "type": "p",
              "text": "“You just want all the power,” he snapped. “We can all tell. You keep taking everyone else’s side!”"
            },
            {
              "type": "p",
              "text": "Something inside Obsidian broke."
            },
            {
              "type": "p",
              "text": "Before he could think, he lunged forward and punched Korrin hard across the face."
            },
            {
              "type": "p",
              "text": "Korrin hit the ground with a cry of pain."
            },
            {
              "type": "p",
              "text": "In one motion, Obsidian drew his sword and pressed the blade against Korrin’s throat."
            },
            {
              "type": "p",
              "text": "The entire camp went silent."
            },
            {
              "type": "p",
              "text": "Obsidian’s breathing was ragged."
            },
            {
              "type": "p",
              "text": "“You will listen to me,” he growled. “I am your captain.”"
            },
            {
              "type": "p",
              "text": "Korrin stared up at him, stunned and terrified."
            },
            {
              "type": "p",
              "text": "“Y-yes sir,” he croaked."
            },
            {
              "type": "p",
              "text": "Obsidian stepped back."
            },
            {
              "type": "p",
              "text": "Korrin curled onto his side, clutching his bleeding nose in agony."
            },
            {
              "type": "p",
              "text": "As Korrin crawled away, clutching his nose, Shadeclaw slowly stepped toward Obsidian."
            },
            {
              "type": "p",
              "text": "“Why would you do that?” she asked quietly."
            },
            {
              "type": "p",
              "text": "Obsidian turned toward her, his anger already fading into guilt."
            },
            {
              "type": "p",
              "text": "“He was being so awful.”"
            },
            {
              "type": "p",
              "text": "“I know,” Shadeclaw said softly. “But that was wrong. That wasn’t you.”"
            },
            {
              "type": "p",
              "text": "Obsidian looked down at the ground."
            },
            {
              "type": "p",
              "text": "“I’m sorry.”"
            },
            {
              "type": "p",
              "text": "Shadeclaw’s expression softened."
            },
            {
              "type": "p",
              "text": "“I know you are.”"
            },
            {
              "type": "p",
              "text": "She stepped closer and wrapped her arms around him again. After a moment, she kissed him gently on the cheek."
            },
            {
              "type": "p",
              "text": "In only a few hours, they would leave for Foranar 5."
            }
          ]
        },
        {
          "number": 20,
          "title": "Chapter 20",
          "paragraphs": [
            {
              "type": "p",
              "text": "The Roboto Armada transport ship was approaching Foranar 5."
            },
            {
              "type": "p",
              "text": "As it descended through the atmosphere, Obsidian stared out the window in amazement. The Shadow Armada was somehow still holding out against the robots. The attack had begun at midnight, and now it was noon. Even after twelve hours, robots were still pouring from the Roboto Armada base."
            },
            {
              "type": "p",
              "text": "The mission to the Prism Armada would begin soon, though, so he forced himself to focus."
            },
            {
              "type": "p",
              "text": "It was a lot of waiting."
            },
            {
              "type": "p",
              "text": "And waiting."
            },
            {
              "type": "p",
              "text": "And guess what? more waiting."
            },
            {
              "type": "p",
              "text": "Eventually, everyone settled down and began talking among themselves. Shadeclaw sat beside him, though neither of them seemed to know what to say."
            },
            {
              "type": "p",
              "text": "Finally, she broke the silence."
            },
            {
              "type": "p",
              "text": "\"Hey, you're going to do great out there.\""
            },
            {
              "type": "p",
              "text": "\"You can't guarantee that.\""
            },
            {
              "type": "p",
              "text": "\"Yes, I can,\" she said with a small smile. \"Because they want the same thing as you.\""
            },
            {
              "type": "p",
              "text": "This time, he hugged her."
            },
            {
              "type": "p",
              "text": "\"Thank you so much.\""
            },
            {
              "type": "p",
              "text": "His voice cracked, and he felt tears beginning to form."
            },
            {
              "type": "p",
              "text": "Then Shadeclaw did something unexpected."
            },
            {
              "type": "p",
              "text": "She gently pulled away from the hug."
            },
            {
              "type": "p",
              "text": "For a second, Obsidian thought she was leaving."
            },
            {
              "type": "p",
              "text": "Instead, she leaned closer and kissed him."
            },
            {
              "type": "p",
              "text": "Not on the cheek this time."
            },
            {
              "type": "p",
              "text": "The touch was soft and warm, and for a brief moment the war, the armies, and the impossible mission ahead seemed to disappear."
            },
            {
              "type": "p",
              "text": "All that mattered was her."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "The robot escort was ready."
            },
            {
              "type": "p",
              "text": "All the other robots had already left the base and were fighting elsewhere on the planet. Obsidian would walk at the front, his army behind him, while a ring of robots surrounded them on all sides."
            },
            {
              "type": "p",
              "text": "When they reached the Prism Armada's wall, Obsidian immediately saw that the robots had done their job well. A massive section had been blasted open, allowing them to enter without resistance."
            },
            {
              "type": "p",
              "text": "As they walked through the city, people stared."
            },
            {
              "type": "p",
              "text": "Some pointed."
            },
            {
              "type": "p",
              "text": "Others whispered."
            },
            {
              "type": "p",
              "text": "Obsidian could feel their eyes following him."
            },
            {
              "type": "p",
              "text": "It was frustrating not knowing what they were saying."
            },
            {
              "type": "p",
              "text": "Soon the castle came into view."
            },
            {
              "type": "p",
              "text": "That was when Shadeclaw began trying to push her way through the wall of robots protecting him."
            },
            {
              "type": "p",
              "text": "\"Excuse me.\""
            },
            {
              "type": "p",
              "text": "The robots didn't move."
            },
            {
              "type": "p",
              "text": "\"Excuse me!\""
            },
            {
              "type": "p",
              "text": "Still nothing."
            },
            {
              "type": "p",
              "text": "One robot gently pushed her back into place."
            },
            {
              "type": "p",
              "text": "Obsidian watched for a moment, trying not to laugh."
            },
            {
              "type": "p",
              "text": "She looked absolutely furious."
            },
            {
              "type": "p",
              "text": "Finally he waved a hand."
            },
            {
              "type": "p",
              "text": "\"Let her through.\""
            },
            {
              "type": "p",
              "text": "Shadeclaw marched over immediately."
            },
            {
              "type": "p",
              "text": "\"Why didn't you let me through earlier?!\""
            },
            {
              "type": "p",
              "text": "\"'Cause it was funny.\""
            },
            {
              "type": "p",
              "text": "The glare she gave him could have melted steel."
            },
            {
              "type": "p",
              "text": "Together they entered the castle."
            },
            {
              "type": "p",
              "text": "Two guards stepped into their path."
            },
            {
              "type": "p",
              "text": "\"What do you think you're doing?\" one demanded."
            },
            {
              "type": "p",
              "text": "Obsidian straightened."
            },
            {
              "type": "p",
              "text": "\"We're here to see your leader. We want your help destroying the Shadow Armada on this planet.\""
            },
            {
              "type": "p",
              "text": "The guards exchanged a glance."
            },
            {
              "type": "p",
              "text": "After a long pause, one sighed."
            },
            {
              "type": "p",
              "text": "\"Fine.\""
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "They walked down a long hallway exactly as the guards had instructed."
            },
            {
              "type": "p",
              "text": "The corridor seemed endless, lined with white stone and glowing crystal lamps. At the far end stood an enormous golden door."
            },
            {
              "type": "p",
              "text": "Obsidian pushed it open."
            },
            {
              "type": "p",
              "text": "Inside, a woman sat upon a throne of polished crystal."
            },
            {
              "type": "p",
              "text": "As soon as she saw him, she stood."
            },
            {
              "type": "p",
              "text": "Her glowing white eyes narrowed."
            },
            {
              "type": "p",
              "text": "\"You're from the Shadow Armada?\""
            },
            {
              "type": "p",
              "text": "Obsidian shook his head."
            },
            {
              "type": "p",
              "text": "\"No. The Shadow Armada is my enemy. The Roboto Armada and I are here because we want your help destroying them.\""
            },
            {
              "type": "p",
              "text": "The room fell silent."
            },
            {
              "type": "p",
              "text": "The leader studied him for a long moment."
            },
            {
              "type": "p",
              "text": "Finally, she spoke."
            },
            {
              "type": "p",
              "text": "\"Fine.\""
            },
            {
              "type": "p",
              "text": "Obsidian blinked."
            },
            {
              "type": "p",
              "text": "\"Fine?\""
            },
            {
              "type": "p",
              "text": "\"For now,\" she said coldly."
            },
            {
              "type": "p",
              "text": "She rose from her throne and stepped forward."
            },
            {
              "type": "p",
              "text": "\"And your army will rebuild my wall.\""
            },
            {
              "type": "p",
              "text": "Her pale hands began to glow with crackling energy."
            },
            {
              "type": "p",
              "text": "\"Now leave.\""
            },
            {
              "type": "p",
              "text": "Obsidian decided that was probably a good idea."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Obsidian's army had decided they would storm the main fort while the other armies dealt with the smaller strongholds scattered across Foranar 5. As for Obsidian, he intended to face whoever was leading the base himself."
            },
            {
              "type": "p",
              "text": "He was still wondering who that might be when a familiar voice spoke behind him."
            },
            {
              "type": "p",
              "text": "\"Long time no see.\""
            },
            {
              "type": "p",
              "text": "Obsidian looked up in surprise."
            },
            {
              "type": "p",
              "text": "\"Onyx?\""
            },
            {
              "type": "p",
              "text": "Onyx grinned."
            },
            {
              "type": "p",
              "text": "\"Yep.\""
            },
            {
              "type": "p",
              "text": "\"How long have you been here? With my army?\""
            },
            {
              "type": "p",
              "text": "\"Long enough to notice you look older. Not long enough to know why.\""
            },
            {
              "type": "p",
              "text": "\"Oh. Uh...\""
            },
            {
              "type": "p",
              "text": "The silence stretched for a moment."
            },
            {
              "type": "p",
              "text": "Then Onyx spoke again."
            },
            {
              "type": "p",
              "text": "\"Is Shadeclaw okay?\""
            },
            {
              "type": "p",
              "text": "Obsidian blinked."
            },
            {
              "type": "p",
              "text": "\"Yeah. Why wouldn't she be?\""
            },
            {
              "type": "p",
              "text": "Onyx shrugged."
            },
            {
              "type": "p",
              "text": "\"Because you guys are fugitives. You never know.\""
            },
            {
              "type": "p",
              "text": "\"Oh.\""
            },
            {
              "type": "p",
              "text": "To his surprise, tears started to well up in his eyes."
            },
            {
              "type": "p",
              "text": "\"I'm glad you're here.\""
            },
            {
              "type": "p",
              "text": "Onyx smiled."
            },
            {
              "type": "p",
              "text": "\"Great! So... what do you want to do now?\""
            },
            {
              "type": "p",
              "text": "Obsidian looked up at the sky."
            },
            {
              "type": "p",
              "text": "\"How about a night among the stars? We could go for a ride in a starship.\""
            },
            {
              "type": "p",
              "text": "Onyx laughed."
            },
            {
              "type": "p",
              "text": "\"Now that's an idea.\""
            },
            {
              "type": "p",
              "text": "As they flew through the sky, onyx teased, \"something's changed between you two!\""
            },
            {
              "type": "p",
              "text": "They groaned"
            },
            {
              "type": "p",
              "text": "\"Have you been talking?\" When they both glared at her, she \"ooh'd\" until she couldn't through her laughs."
            },
            {
              "type": "p",
              "text": "Obsidian tackled her, and shadeclaw helped. they soon had her in a choke hold and she was tapping."
            },
            {
              "type": "p",
              "text": "When they let her go, they all laughed. \"This is nice.\" shadeclaw sighed"
            }
          ]
        },
        {
          "number": 21,
          "title": "Chapter 21",
          "paragraphs": [
            {
              "type": "p",
              "text": "As Obsidian's army reached the Shadow Armada camps, they made quick work of the inexperienced recruits stationed there."
            },
            {
              "type": "p",
              "text": "The real challenge came when they approached the Shadow Armada base."
            },
            {
              "type": "p",
              "text": "A massive wall towered over them."
            },
            {
              "type": "p",
              "text": "Obsidian frowned."
            },
            {
              "type": "p",
              "text": "Their soldiers carried swords and bows."
            },
            {
              "type": "p",
              "text": "The wall did not care."
            },
            {
              "type": "p",
              "text": "For a moment, the advance stalled."
            },
            {
              "type": "p",
              "text": "Then robots marched past them."
            },
            {
              "type": "p",
              "text": "Arrow after arrow rained down from above, striking metal armor, but the robots never stopped. They reached the wall and unleashed a barrage of explosives."
            },
            {
              "type": "p",
              "text": "The ground shook."
            },
            {
              "type": "p",
              "text": "Stone cracked."
            },
            {
              "type": "p",
              "text": "A huge section of the wall collapsed."
            },
            {
              "type": "p",
              "text": "\"Thank you!\" several of Obsidian's soldiers shouted."
            },
            {
              "type": "p",
              "text": "The robots simply beeped in response."
            },
            {
              "type": "p",
              "text": "The army charged through the gap and into the city."
            },
            {
              "type": "p",
              "text": "As they advanced, Bloodhounds recognized who Obsidian was and began joining the rebellion. Their force grew larger with every street they crossed."
            },
            {
              "type": "p",
              "text": "Then they stopped."
            },
            {
              "type": "p",
              "text": "Ahead of them stood a massive army."
            },
            {
              "type": "p",
              "text": "The King's Black Guard."
            },
            {
              "type": "p",
              "text": "The best of the best."
            },
            {
              "type": "p",
              "text": "Even from a distance, Obsidian could tell these soldiers were different."
            },
            {
              "type": "p",
              "text": "The city fell silent."
            },
            {
              "type": "p",
              "text": "Then he remembered."
            },
            {
              "type": "p",
              "text": "A plan."
            },
            {
              "type": "p",
              "text": "\"Vanthel!\" he shouted. \"You've got this! Use your powers!\""
            },
            {
              "type": "p",
              "text": "Vanthel froze."
            },
            {
              "type": "p",
              "text": "\"But I can't.\""
            },
            {
              "type": "p",
              "text": "For the first time, Obsidian saw genuine fear in his eyes."
            },
            {
              "type": "p",
              "text": "\"You can do this,\" Obsidian said. \"I'll pull our soldiers back.\""
            },
            {
              "type": "p",
              "text": "Vanthel swallowed hard."
            },
            {
              "type": "p",
              "text": "Then he nodded."
            },
            {
              "type": "p",
              "text": "\"Okay. I'll do it for our glory... and for the king's fall.\""
            },
            {
              "type": "p",
              "text": "Obsidian turned."
            },
            {
              "type": "p",
              "text": "\"ALL SOLDIERS, FALL BACK!\""
            },
            {
              "type": "p",
              "text": "The rebels scrambled away."
            },
            {
              "type": "p",
              "text": "A heartbeat later, darkness exploded from Vanthel's hands."
            },
            {
              "type": "p",
              "text": "A beam of black energy ripped across the battlefield."
            },
            {
              "type": "p",
              "text": "The earth trembled."
            },
            {
              "type": "p",
              "text": "The air screamed."
            },
            {
              "type": "p",
              "text": "When the light finally faded, the Black Guard was gone."
            },
            {
              "type": "p",
              "text": "Silence settled over the city."
            },
            {
              "type": "p",
              "text": "Only the castle remained."
            },
            {
              "type": "p",
              "text": "And beyond it..."
            },
            {
              "type": "p",
              "text": "Victory."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "When they reached the castle, Obsidian's soldiers began to notice something strange."
            },
            {
              "type": "p",
              "text": "The King's Black Guard had been almost the entire defense force."
            },
            {
              "type": "p",
              "text": "They rarely saw Bloodhounds."
            },
            {
              "type": "p",
              "text": "Even swordsmen in training were scarce."
            },
            {
              "type": "p",
              "text": "It was as if the enemy had expected the Black Guard to stop them."
            },
            {
              "type": "p",
              "text": "Obsidian chose only a few companions to enter the castle with him."
            },
            {
              "type": "p",
              "text": "Korrin."
            },
            {
              "type": "p",
              "text": "Shadeclaw."
            },
            {
              "type": "p",
              "text": "Onyx."
            },
            {
              "type": "p",
              "text": "Vanthel."
            },
            {
              "type": "p",
              "text": "Together they pushed open the jewel-encrusted doors."
            },
            {
              "type": "p",
              "text": "The doors creaked loudly."
            },
            {
              "type": "p",
              "text": "Then they saw who was waiting inside."
            },
            {
              "type": "p",
              "text": "Everyone froze."
            },
            {
              "type": "p",
              "text": "A real Dark Warrior."
            },
            {
              "type": "p",
              "text": "Not one of the imperfect results from Project Dark Warrior."
            },
            {
              "type": "p",
              "text": "Not a failed experiment."
            },
            {
              "type": "p",
              "text": "The real thing."
            },
            {
              "type": "p",
              "text": "And she was far more terrifying than any of them had imagined."
            },
            {
              "type": "p",
              "text": "Vanthel reacted first."
            },
            {
              "type": "p",
              "text": "A beam of black energy shot from his hands."
            },
            {
              "type": "p",
              "text": "The Dark Warrior raised her arm and fired a beam of her own."
            },
            {
              "type": "p",
              "text": "The attacks collided."
            },
            {
              "type": "p",
              "text": "The castle shook."
            },
            {
              "type": "p",
              "text": "\"HOW DARE YOU CHALLENGE THE GREAT VANTA?!\" she shrieked."
            },
            {
              "type": "p",
              "text": "With a flick of her hand, invisible force slammed them all into the floor."
            },
            {
              "type": "p",
              "text": "Obsidian struggled to breathe."
            },
            {
              "type": "p",
              "text": "Vanta raised her hand."
            },
            {
              "type": "p",
              "text": "Dark energy gathered in her palm."
            },
            {
              "type": "p",
              "text": "She was about to fire."
            },
            {
              "type": "p",
              "text": "Obsidian lunged."
            },
            {
              "type": "p",
              "text": "His blade flashed."
            },
            {
              "type": "p",
              "text": "Vanta's arm hit the ground."
            },
            {
              "type": "p",
              "text": "Without hesitation, he swung for her throat."
            },
            {
              "type": "p",
              "text": "But she vanished."
            },
            {
              "type": "p",
              "text": "Telekinesis hurled him backward."
            },
            {
              "type": "p",
              "text": "Shadeclaw charged."
            },
            {
              "type": "p",
              "text": "\"Don't lay a finger on him!\""
            },
            {
              "type": "p",
              "text": "She attacked with everything she had."
            },
            {
              "type": "p",
              "text": "At the same moment, Vanthel unleashed another beam."
            },
            {
              "type": "p",
              "text": "Vanta answered with a shimmering shield of dark energy."
            },
            {
              "type": "p",
              "text": "The beam shattered against it."
            },
            {
              "type": "p",
              "text": "\"GET DOWN, TRAITOR!\" Vanta screamed."
            },
            {
              "type": "p",
              "text": "Invisible force slammed Vanthel into a wall."
            },
            {
              "type": "p",
              "text": "The impact cracked stone."
            },
            {
              "type": "p",
              "text": "Before she could attack again, Obsidian struck."
            },
            {
              "type": "p",
              "text": "His sword cut clean through her neck."
            },
            {
              "type": "p",
              "text": "For a moment, everything went still."
            },
            {
              "type": "p",
              "text": "Then Vanta burst into black fire."
            },
            {
              "type": "p",
              "text": "The flames consumed her completely."
            },
            {
              "type": "p",
              "text": "And she was gone."
            },
            {
              "type": "p",
              "text": "Silence filled the castle."
            },
            {
              "type": "p",
              "text": "Then everyone turned."
            },
            {
              "type": "p",
              "text": "Vanthel was floating."
            },
            {
              "type": "p",
              "text": "Black flames danced around him without burning him."
            },
            {
              "type": "p",
              "text": "His eyes widened."
            },
            {
              "type": "p",
              "text": "\"Guys...\""
            },
            {
              "type": "p",
              "text": "He slowly descended back to the floor."
            },
            {
              "type": "p",
              "text": "\"I'm a real Dark Warrior.\""
            },
            {
              "type": "p",
              "text": "Nobody knew what to say."
            },
            {
              "type": "p",
              "text": "Finally, Vanthel walked over, picked up the unconscious Korrin and Onyx, and headed for the door."
            },
            {
              "type": "p",
              "text": "\"Come on,\" he said. \"We need to get everyone healed up and ready.\""
            },
            {
              "type": "p",
              "text": "He glanced back at the throne room."
            },
            {
              "type": "p",
              "text": "\"Because the Shadow Armada is definitely coming back.\""
            }
          ]
        },
        {
          "number": 22,
          "title": "Chapter 22",
          "paragraphs": [
            {
              "type": "p",
              "text": "The next day, they settled into the Shadow Armada base."
            },
            {
              "type": "p",
              "text": "For the first time in what felt like forever, Obsidian was surrounded by walls that actually made him feel safe. The rebuilt wall stood strong around the city, and just knowing it was there gave him a sense of security he hadn't felt in a long time."
            },
            {
              "type": "p",
              "text": "He also got to spend more time with Shadeclaw."
            },
            {
              "type": "p",
              "text": "That was definitely a bonus."
            },
            {
              "type": "p",
              "text": "Meanwhile, Vanthel had begun giving the other Dark Warriors lessons on how to control and use their magic."
            },
            {
              "type": "p",
              "text": "To everyone's surprise, they were improving quickly."
            },
            {
              "type": "p",
              "text": "\"You're better than I expected,\" Vanthel admitted."
            },
            {
              "type": "p",
              "text": "The Dark Warriors looked at each other proudly."
            },
            {
              "type": "p",
              "text": "For once, things almost felt normal."
            },
            {
              "type": "p",
              "text": "Almost."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "After a couple of days, things changed for the worse."
            },
            {
              "type": "p",
              "text": "A new, stronger Shadow Armada base had sprung up nearby, and Vanthel was still trying to figure out how to use his new powers—which wasn't exactly in everyone's best interest."
            },
            {
              "type": "p",
              "text": "Now Obsidian had to deal with angry people, the Shadow Armada, and the Prism Armada, who were furious because they had \"lost a lot of good men\" during the fight to take the base."
            },
            {
              "type": "p",
              "text": "And then there was Shadeclaw."
            },
            {
              "type": "p",
              "text": "She was upset that Obsidian barely had any time for her anymore. He was so busy dealing with everyone else's problems that he hardly had time to deal with theirs."
            },
            {
              "type": "p",
              "text": "Obsidian was beginning to realize something."
            },
            {
              "type": "p",
              "text": "Winning a battle was easy compared to keeping everyone together."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Obsidian returned to his and Shadeclaw's sleeping quarters."
            },
            {
              "type": "p",
              "text": "Shadeclaw was waiting for him."
            },
            {
              "type": "p",
              "text": "And she was furious."
            },
            {
              "type": "p",
              "text": "\"We need to talk.\""
            },
            {
              "type": "p",
              "text": "Obsidian froze."
            },
            {
              "type": "p",
              "text": "He immediately became fearful. When Shadeclaw wanted to, she could make Vanta look like a cuddling kitten."
            },
            {
              "type": "p",
              "text": "\"Yes?\" he squeaked."
            },
            {
              "type": "p",
              "text": "\"Why didn't you come to Pinky Out Trout with me? I thought we scheduled it for three!\""
            },
            {
              "type": "p",
              "text": "\"Well, I was setting up patrols. When I was walking to Pinky Out Trout, people started storming me with complaints about Vanthel. I couldn't make it before I had listened to half of them.\""
            },
            {
              "type": "p",
              "text": "Shadeclaw's expression softened."
            },
            {
              "type": "p",
              "text": "\"Oh.\""
            },
            {
              "type": "p",
              "text": "She looked down for a moment."
            },
            {
              "type": "p",
              "text": "\"Sorry, Obsidian. I've just been missing you too much.\""
            },
            {
              "type": "p",
              "text": "\"Why don't we go now?\""
            },
            {
              "type": "p",
              "text": "\"Yes! Let's do it!!!\" Shadeclaw screamed, jumping up and down."
            },
            {
              "type": "p",
              "text": "Thirty minutes later, they were sitting at the fanciest trout-only restaurant in the base, enjoying their meals—with their pinkies up, of course."
            },
            {
              "type": "p",
              "text": "\"It's nice going out again,\" Shadeclaw whispered, taking a bite of her trout."
            },
            {
              "type": "p",
              "text": "\"I agree,\" Obsidian said, nervously glancing around the restaurant."
            },
            {
              "type": "p",
              "text": "\"What is it this time?\" Shadeclaw asked, exasperated."
            },
            {
              "type": "p",
              "text": "\"Just worried about someone coming in and yelling about how Vanthel vaporized their favorite pillow because they left it lying in the street,\" Obsidian said, rolling his eyes."
            },
            {
              "type": "p",
              "text": "Just then, someone burst into the restaurant."
            },
            {
              "type": "p",
              "text": "Obsidian recognized him immediately as one of the more ridiculous complainers."
            },
            {
              "type": "p",
              "text": "What is it this time? he thought, exasperated."
            },
            {
              "type": "p",
              "text": "But what the Bloodhound said surprised him."
            },
            {
              "type": "p",
              "text": "\"Obsidian! The Shadow Armada is attacking us! They just reached the wall—they're attacking it!\""
            },
            {
              "type": "p",
              "text": "Obsidian's expression changed instantly."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "Obsidian warped to the wall, bringing a disappointed Shadeclaw and a very confident Vanthel with him."
            },
            {
              "type": "p",
              "text": "The wall was already beginning to crumble."
            },
            {
              "type": "p",
              "text": "On the other side stood an army of real Dark Warriors."
            },
            {
              "type": "p",
              "text": "None of them seemed quite as powerful as Vanta had been, but together, their power was overwhelming. Waves of dark energy slammed against the defenses, slowly tearing them apart."
            },
            {
              "type": "p",
              "text": "And in the middle of it all stood one Dark Warrior who immediately caught Obsidian's attention."
            },
            {
              "type": "p",
              "text": "They stood at the command position, watching the attack with a calm, calculating expression."
            },
            {
              "type": "p",
              "text": "Powerful."
            },
            {
              "type": "p",
              "text": "Cunning."
            },
            {
              "type": "p",
              "text": "And very much in control."
            },
            {
              "type": "break"
            },
            {
              "type": "p",
              "text": "\"My word!\" Vanthel exclaimed when he noticed the commander."
            },
            {
              "type": "p",
              "text": "Obsidian looked at him. \"What?\""
            },
            {
              "type": "p",
              "text": "\"That's one of the researchers from the science labs! Malvek!\""
            },
            {
              "type": "p",
              "text": "Obsidian turned back toward the Dark Warrior standing at the center of the attacking army."
            },
            {
              "type": "p",
              "text": "\"Must've taken over after Vanta died,\" he said thoughtfully."
            },
            {
              "type": "p",
              "text": "Obsidian and Shadeclaw grabbed bows while Vanthel prepared to fight with his powers."
            },
            {
              "type": "p",
              "text": "Together, they joined the defenders on the wall, firing down at the attacking Dark Warriors."
            },
            {
              "type": "p",
              "text": "But Obsidian knew they couldn't defend from up there forever."
            },
            {
              "type": "p",
              "text": "He ordered a group of Bloodhounds down to meet the enemy in close combat, then joined them with Vanthel at his side."
            },
            {
              "type": "p",
              "text": "\"Push forward!\" Obsidian yelled."
            },
            {
              "type": "p",
              "text": "His soldiers answered with a roar and charged."
            },
            {
              "type": "p",
              "text": "They fought their way through Dark Warrior after Dark Warrior, slowly forcing the attackers back. But the Dark Warriors resisted fiercely, and the Bloodhounds were taking losses too."
            },
            {
              "type": "p",
              "text": "Neither side was giving in."
            },
            {
              "type": "p",
              "text": "Just then, the defenders on the wall started shouting."
            },
            {
              "type": "p",
              "text": "Obsidian looked up to see what was happening."
            },
            {
              "type": "p",
              "text": "The wall was crumbling."
            },
            {
              "type": "p",
              "text": "The defenders scrambled to either side as a massive section gave way, leaving a huge gap in their defenses."
            },
            {
              "type": "p",
              "text": "\"My word,\" Obsidian whispered."
            },
            {
              "type": "p",
              "text": "Then he snapped back into command."
            },
            {
              "type": "p",
              "text": "\"Shadowkiller! Go get reinforcements!\""
            },
            {
              "type": "p",
              "text": "he ran off and warped away. Seconds later, he came back with a large force of bloodhounds"
            }
          ]
        }
      ]
    }
  ]
};

const BOOK_TOTAL_CHAPTERS = BOOK_DATA.parts.reduce((n,p)=>n+p.chapters.length,0);
